<template>
  <div>
    <div class="title-lable-error">
      <span class="ml-3">Your account balance is insufficient</span>
    </div>
    <div
      class="d-flex flex-row mt-3 ml-3"
      style="color: #757575; font-size: 0.85rem"
    >
      <div v-if="needMoreValue" class="d-flex flex-row align-items-center">
        <span>You will need to deposit an additional</span>
        <span class="ml-1 mr-1" style="color: #42a5f5">{{
          needMoreValue
        }}</span>
        <img
          class="mr-1"
          src="/logo/logo-irender-coin.svg"
          width="11"
          height="11"
        />
        <span>to perform this action.</span>
      </div>
      <div v-else>Your account isn't enough to do this.</div>
      <el-link
        :href="routeUrl.RECHARGE"
        class="ml-1"
        :underline="false"
        type="primary"
        target="_blank"
        >Recharge now</el-link
      >
    </div>
  </div>
</template>

<script>
import base from "@/scripts/base";

export default {
  extends: base,

  props: {
    needMoreValue: {
      type: String,
      default: null,
    },
  },
};
</script>